// SELECTION TYPES alphabetized by label for UI
import { MedicalRuleSelectionTypes } from "../medicalPlanBenefit";

export enum QUEUE_RULE_CLAIM_SELECTION_TYPES {
  // medical_claims && medical_claim_versions
  assignment_of_benefits = "Assignment of Benefits",
  bill_type_code = "Bill Type Code",
  billed_amount = "Billed Amount",
  billing_provider_first_name = "Billing Provider First Name",
  billing_provider_last_name_or_organization_name = "Billing Provider Last Name or Organization Name",
  billing_provider_primary_taxonomy_code = "Billing Provider Taxonomy",
  billing_provider_state = "Billing Provider State",
  billing_provider_tin = "Billing Provider TIN",
  claim_type = "Claim Type",
  custom_pend_reason = "Custom Pend Reason",
  did_auto_adjudicate = "Did Auto Adjudicate",
  direct_member_reimbursement_indicator = "Direct Member Reimbursement Indicator",
  frequency_type_code = "Frequency Type Code",
  last_processed_by = "Last Processed By",
  network = "Network",
  network_source = "Submitter",
  pend_reason = "Standard Pend Reason",
  place_of_service = "Place of Service",
  received_at = "Claim Received Date",
  rendering_provider_first_name = "Rendering Provider First Name",
  rendering_provider_last_name_or_organization_name = "Rendering Provider Last Name or Organization Name",
  rendering_provider_primary_taxonomy_code = "Rendering Provider Taxonomy",
  total_plan_pay_amount = "Plan Pay Amount",
}

export const QUEUE_RULE_CLAIM_SELECTION_TYPES_FILTERS = {
  claim_type: ["medical"],
};

export enum QUEUE_RULE_SERVICE_LINE_SELECTION_TYPES {
  // medical_service_line_item_versions
  additional_diagnosis_code = "Additional Diagnosis",
  admitting_diagnosis_code = "Admitting Diagnosis",
  amount_applied_to_deductible = "Service Line Deductible Amount",
  any_procedure_code = "Procedure Code",
  any_preventive_category = "Any Preventive Category",
  any_service_category = "Any Service Category",
  claim_adjustment_group_code = "Claim Adjustment Group Code",
  claim_adjustment_reason_code = "Claim Adjustment Reason Code",
  principal_diagnosis_code = "Principal Diagnosis",
  procedure_modifier = "Modifier Codes",
  remark_code = "Remark Code",
  revenue_code = "Revenue Code",
  service_date = "Date of Service",
}

export enum QUEUE_RULE_MEMBER_SELECTION_TYPES {
  external_group_id = "Member Group",
  // member versions
  member_age = "Member Age",
  member_first_name = "Member First Name",
  member_last_name = "Member Last Name",
  member_social_security_number = "Member Social Security Number",
  member_state = "Member State",
  member_zip_code = "Member Zip Code",
  person_code = "Person Code",
}

export const QUEUE_RULE_SELECTION_TYPES = {
  ...QUEUE_RULE_CLAIM_SELECTION_TYPES,
  ...QUEUE_RULE_MEMBER_SELECTION_TYPES,
  ...QUEUE_RULE_SERVICE_LINE_SELECTION_TYPES,
};

// OPERATORS
export enum ANY_OF_OPERATORS {
  is_any_of = "Is Any Of",
  is_not_any_of = "Is Not Any Of",
}

export enum EQUALS {
  equals = "Equals",
}

export enum EQUALITY_OPERATORS {
  equals = "Equals",
  does_not_equal = "Does Not Equal",
}

export enum EQUALITY_TIME_OPERATORS {
  on_or_before = "On or Before",
  on_or_after = "On or After",
}

export enum INEQUALITY_WITH_EQUALS_OPERATORS {
  equals = "Equals",
  is_greater_than_or_equals = "Greater Than or Equals",
  is_lesser_than_or_equals = "Less Than or Equals",
}

export enum LESS_OR_GREATER_EQUALS_OPERATORS {
  is_greater_than_or_equals = "Greater Than or Equals",
  is_lesser_than_or_equals = "Less Than or Equals",
}

export enum OVERLAP_OPERATORS {
  has_overlap = "Overlaps",
  does_not_overlap = "Does Not Overlap",
}

export enum SEARCH_OPERATORS {
  equals = "Equals",
  starts_with = "Starts With",
}

export enum SEARCH_STARTS_WITH_ANY_OF_OPERATORS {
  equals = "Equals",
  starts_with = "Starts With",
  any_of_starts_with = "Starts With Any Of",
}

export const OPERATORS = {
  ...ANY_OF_OPERATORS,
  ...EQUALITY_OPERATORS,
  ...EQUALITY_TIME_OPERATORS,
  ...INEQUALITY_WITH_EQUALS_OPERATORS,
  ...OVERLAP_OPERATORS,
  ...SEARCH_OPERATORS,
  ...SEARCH_STARTS_WITH_ANY_OF_OPERATORS,
};

export enum EQUAL_OPERATORS {
  equals = "Equals",
  does_not_equal = "Does Not Equal",
}

export enum COMPARISON_OPERATORS {
  is_greater_than_or_equal = "Greater than or Equal",
  is_lesser_than_or_equal = "Less than or Equal",
}

export const NETWORK_OPERATORS = {
  ...ANY_OF_OPERATORS,
  ...EQUALITY_OPERATORS,
  ...COMPARISON_OPERATORS,
  ...OVERLAP_OPERATORS,
};

export interface RuleCondition {
  readonly operator: OperatorValues;
  readonly selection: QueueRuleSelectionType | MedicalRuleSelectionTypes;
  readonly value: string | ReadonlyArray<string> | ReadonlyArray<number>;
}

export type OperatorValues = keyof typeof OPERATORS;
export type QueueRuleSelectionType = keyof typeof QUEUE_RULE_SELECTION_TYPES;
